export default __webpack_public_path__ + "static/media/taskmanager560-dashboard.056503b1.png";